import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME, LargeDataAnalyticsHostname} from "../Configs/Domain";



export const fetchTimeSeriesData = createAsyncThunk(
    'timeSeries/fetchTimeSeriesData',
    async({symbols, startDate, endDate}, { getState, rejectWithValue})=>{
      const url = `${HOSTNAME}/timeseries/fetch?symbols=${symbols.join(',')}&sd=${startDate}&ed=${endDate}`;
      try{
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        console.log(data)
        return { data };
      } catch (error) {
        return rejectWithValue(error.toString());
      }
    }
)




export const fetchSimulationData = createAsyncThunk(
  'simulations/fetchData',
  async ({ modelName, symbols, startDate, endDate, nTrials, nSteps, nSamples }, { rejectWithValue }) => {
    try {
      // Construct the URL with query parameters
      let url = `${LargeDataAnalyticsHostname}/simulations/${modelName}?`;
      url += `symbols=${encodeURIComponent(symbols.join(','))}&`;
      url += `sd=${startDate}&`;
      url += `ed=${endDate}&`;
      url += `n_trials=${nTrials}&`;
      url += `n_steps=${nSteps}&`;
      url += `n_samples=${nSamples}`;

      // Use fetch or any other HTTP client that you prefer
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return { modelName, data };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);



export const fetchBlendedTimeseries = createAsyncThunk(
  'timeSeries/fetchBlended',
  async ({ mapping }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ mapping }).toString();
      const url = `${HOSTNAME}/timeseries/blend?${params}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);
